import { NextPage } from 'next'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { PagePropsWrapper } from 'lib/routing/nextPageUtils'
import { PrivacyPolicy } from 'experiences/privacy'
import { LegalAgreement } from 'services/Directus/collections/legal_agreements'

interface Props {
	legalAgreement: LegalAgreement | null
}

const Privacy: NextPage<PagePropsWrapper<Props>> = ({ metaTags }): JSX.Element => (
	<StandardLayout metaTags={metaTags}>
		<PrivacyPolicy />
	</StandardLayout>
)

export default Privacy
